import { getBrandPLPState } from '../feature.selector';
import { BrandPLPPageState } from '../state';
import { createSelector } from '@ngrx/store';
import { SortState } from './sort.state';

export const getSortState = createSelector(getBrandPLPState,
  (state: BrandPLPPageState) => state && state.sort
);

export const getSortOption = createSelector(getSortState,
  (state: SortState) => state && state.sortOption
);
